import { render, staticRenderFns } from "./DateRangePicker.vue?vue&type=template&id=1053be46&scoped=true&lang=pug"
import script from "./DateRangePicker.vue?vue&type=script&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1053be46",
  null
  
)

export default component.exports